'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var AccordionHeading = react.forwardRef(function (props, ref) {
  var _className = utils.cx('chakra-accordion__heading', props.className);
  var styles = react.useStyles();
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.h2, _extends__default["default"]({
    className: _className,
    __css: styles.heading,
    ref: ref
  }, props));
});
exports.AccordionHeading = AccordionHeading;